"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title2QuoteTable = exports.Title1QuoteTable = void 0;
var react_1 = __importDefault(require("react"));
var _1 = require(".");
require("./index.less");
var middle_1 = require("../../../quotetable/middle");
function Title1QuoteTable(props) {
    return (react_1.default.createElement("div", { className: "title1quotetable ".concat(props.tagclass) },
        react_1.default.createElement(_1.Title1, null,
            react_1.default.createElement(_1.Title1.Main, null, props.children),
            react_1.default.createElement(_1.Title1.More, null, props.more)),
        react_1.default.createElement("div", { className: "t1qt" },
            react_1.default.createElement(middle_1.QuoteTableMiddle, __assign({}, props)),
            props.bottom_more &&
                react_1.default.createElement("div", { className: "bmore" }, props.bottom_more))));
}
exports.Title1QuoteTable = Title1QuoteTable;
function Title2QuoteTable(props) {
    return (react_1.default.createElement("div", { className: "title2quotetable" },
        react_1.default.createElement(_1.Title2, null,
            react_1.default.createElement(_1.Title2.Main, null, props.children),
            react_1.default.createElement(_1.Title2.More, null, props.more)),
        react_1.default.createElement("div", { className: "t2qt" },
            react_1.default.createElement(middle_1.QuoteTableMiddle, __assign({}, props)),
            props.bottom_more &&
                react_1.default.createElement("div", { className: "bmore" }, props.bottom_more))));
}
exports.Title2QuoteTable = Title2QuoteTable;
